"use client";

import { useAmsterdamBusinessDateClock } from "@/lib/use-fixed-date-voucher-unavailable";
import {
  hasVoucherSalesEnd,
  isVoucherSaleClosed,
} from "@/app/(marketing)/_branded-voucher/voucher-landing-config";

/**
 * Fixronde 1 fe#1934: verbergt `children` zodra één van `dealIds` niet meer te
 * koop is (isVoucherSaleClosed: `retired`, of na de salesEndDate; 182 na
 * 23-12-2026). De server laat zulke bonnen al weg; dit is voor een gids die
 * vóór de Amsterdamse middernacht geopend is en daarna open blijft. Dezelfde
 * klok als de kaarten (timer op de datumgrens, plus focus en zichtbaarheid);
 * zonder bon met een verkoopstop loopt er geen klok.
 * Fixronde 2 fe#1934: `fallback` (standaard niets) staat er na de stop in de
 * plaats van `children`, voor een tekst die niet weg kan maar zonder de bon
 * verder moet (de intro van een gids).
 */
export default function HideAfterSalesStop({ dealIds, fallback = null, children }) {
  const ids = Array.isArray(dealIds) ? dealIds : [dealIds];
  const tracked = ids.some((id) => hasVoucherSalesEnd({ deals_id: id }));
  const clock = useAmsterdamBusinessDateClock(tracked);
  if (ids.some((id) => isVoucherSaleClosed(id, clock))) return fallback;
  return children;
}
